import { useEffect } from "react";
import MultiStepForm from "../../forms/MultiStepForm";
import { useNavigate } from "react-router-dom";

function Regiser() {
  const navigate = useNavigate();
  useEffect(() => {
    const user = localStorage.getItem("user");

    if (user) {
      // Already logged in — go home immediately
      navigate("/", { replace: true });
    }
  }, [navigate]);

  return <MultiStepForm />;
}

export default Regiser;
